{
  "meldungErwerberVeraeussererHeading": "Personnes impliquées",
  "VersicherungsNummerAbkürzung": "N° du bâtiment",
  "Versicherungsnummer": "N° du bâtiment",
  "VersicherungsNr": "Numéro de bâtiment"
}
